import { SfUser, SfUserRole, SfUserRoleId } from "@/types/generalTypes";

export default function (user: SfUser | null, role: SfUserRole | SfUserRole[]) {
  if (!user) {
    return false;
  }
  if (Array.isArray(role)) {
    for (const r of role) {
      if (user.roles.includes(SfUserRoleId[r])) {
        return true;
      }
    }
    return false;
  }
  return user.roles.includes(SfUserRoleId[role]);
}
